import { picoapp } from 'picoapp'

import slaterWelcome from '@/components/slater-welcome.js'

import header from '@/components/header.js'
import productSelection from '@/components/product-selection.js'
import cartDrawer from '@/components/cartDrawer.js'
import cartDrawerItem from '@/components/cartDrawerItem.js'
import accountLogin from '@/components/accountLogin.js'
import product from '@/components/product.js'
import productCounter from '@/components/product-counter.js'
import item from '@/components/item.js'
import modal from '@/components/modal.js'
import slideshow from '@/components/slideshow.js'
import events from '@/components/events.js'
import mm from '@/components/mm.js'
import favorites from '@/components/favorites.js'
import promo from '@/components/promo.js'
// import productValentines from "@/components/product-valentines.js";
import productGift from "@/components/product-gift.js";
import callout from "@/components/callout.js";
import banner from "@/components/banner.js";


const state = {
  cartOpen: false
}

const components = {
  slaterWelcome,
  accountLogin,
  header,
  productSelection,
  cartDrawer,
  cartDrawerItem,
  product,
  productCounter,
  item,
  modal,
  slideshow,
  events,
  mm,
  favorites,
  promo,
  // productValentines,
  productGift,
  callout,
  banner
};

export default picoapp(components, state)
